import React from "react";
import LinkedIn from "../Images/linkedIn_Green.png";
import Dribbble from "../Images/Dribbble_Green.png";
import Instagram from "../Images/Instragram_Green.png";
//import Pic from "../Images/Profile_Picture.png"
import Pics from "../Images/Profile_Picture_01.png"
import "../CSS/Profile.css";
import Resume from "../Document/Vishnu_Resume_Dark_Mode.pdf";


const Profile=()=>{
    return(
        <>
    <div className="designer">
        <div className="socialmediaicons">
            <a href="https://www.linkedin.com/in/vishnu-s-330881189/" rel="noopener"><img src={LinkedIn} alt="LinkedIn" /></a>
            <a href="https://dribbble.com/Vishnu_S" rel="noopener"><img src={Dribbble} alt="Dribbble" /></a>
            <a href="https://www.instagram.com/design.studio57/" ><img src={Instagram} alt="Instagram" /></a>
        </div>
        <div className="profilepic">
            <img src={Pics} alt="Profile"></img>
            <div className="cont">
                <p className="hi">Hi,</p>
                <h1>I'm <span style={{color:"#02B79A"}}>Vishnu</span></h1>
                <p className="productrole">Product designer (Mobile | Web)</p>
                <a href={Resume} download="Vishnu_Resume_Dark_Mode.pdf"><button className="Button">Download Resume</button></a>
                </div>
        </div>
    </div>

        </>
    )
}

export default Profile;